module.exports = __webpack_public_path__ + "assets/img/intro-normal-3.8ea12674.jpg";